import { render, staticRenderFns } from "./ClassStatistic.vue?vue&type=template&id=4aee88be"
import script from "./ClassStatistic.vue?vue&type=script&lang=js"
export * from "./ClassStatistic.vue?vue&type=script&lang=js"
import style0 from "./ClassStatistic.vue?vue&type=style&index=0&id=4aee88be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports